import initFraud from '../initFraud';

const assign = require('lodash/assign');
const get = require('lodash/get');
const pickBy = require('lodash/pickBy');
const optin = require('@flowio/optin');
const session = require('@flowio/session');
const persistSession = require('@flowio/session/lib/persist-session');
const SessionClient = require('@flowio/session/lib/client');

const config = require('../config');
const optionsSuccess = require('./options-success');
const optionsError = require('./options-error');
const { setGeo } = require('../cart');
const syncCartAttributes = require('./sync-cart-attributes');
const { getCart } = require('../cart_unified/cart-unified');

const sessionClient = new SessionClient({ apiBaseUri: config.API_BASE_URI });

function updateSession({ country, currency, language, locale, experience }, options = {}) {
  const sessionId = session.getSessionId();
  const geo = pickBy({ country, currency, language, locale });

  sessionClient.resetSession({
    integration: 'shopify',
    sessionId,
    experience,
    geo,
    onSuccess: (updatedSession) => {
      persistSession(updatedSession);
      initFraud();
      syncCartAttributes(updatedSession, getCart()).then(() => {
        if (updatedSession.experience) {
          const cartGeo = assign({}, session.getGeo(), { experience: get(updatedSession, 'experience.key') });
          setGeo(cartGeo, {
            success: () => optionsSuccess(options, updatedSession),
            error: (geoStatus, geoError) => optionsError(options, geoError),
          });
        } else {
          optionsSuccess(options, updatedSession);
        }

        optin.getAndDisplayOptin({ targetElement: get(window, 'Flow.optinTarget') });
      });
    },
    onError: error => optionsError(options, error),
  });
}

module.exports = updateSession;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/update-session.js